import { trigger, state, style, transition, animate } from '@angular/animations';
import { Location } from '@angular/common';
import { Component, ErrorHandler, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Documents } from 'src/infrastructure/enums/documents';
import { Errors } from 'src/infrastructure/labels/errors';
import { Pages } from 'src/infrastructure/labels/pages';
import { ImageCollection } from 'src/models/DTO/image/imageCollection';
import { Organisation } from 'src/models/DTO/organisation/organisation';
import { WorkHours } from 'src/models/DTO/workHours/WorkHours';
import { WorkingTime } from 'src/models/DTO/workingtime/workingTime';
import { ImagesService } from 'src/services/request/images/images.service';
import { PartnerService } from 'src/services/request/partner/partner.service';
import { HistoryService } from 'src/services/state/history/history.service';

@Component({
  selector: 'app-seller',
  templateUrl: './seller.component.html',
  styleUrls: ['./seller.component.css'],
  animations: [
    trigger('slideInOut', [
      state(
        'in',
        style({
          overflow: 'hidden',
          height: '*',
        })
      ),
      state(
        'out',
        style({
          overflow: 'hidden',
          height: '7em',
        })
      ),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out')),
    ]),
  ]
})
export class SellerComponent extends HistoryBaseComponent implements OnInit {

  private _partner?: Organisation;
  private _partnerImages: ImageCollection = { data: [] };
  public isDescrExpanded = false;

  private _assetsDocumentStringPath = 'https://app.shareme.co/assets/docs/'

  constructor(
    private activatedRoute: ActivatedRoute,
    private partnerService: PartnerService,
    private imagesService: ImagesService,
    private toast: ToastrService,
    protected locationService: Location,
    protected historyService: HistoryService
  ) {
    super(locationService, historyService);
    this._pageTitle = 'partnerinfo'
    this.loadData();
  }

  ngOnInit(): void {
  }

  private async loadData() {
    this.activatedRoute.params.subscribe(urlParams => {
      this.partnerService.getPartnerInfo(urlParams.id).subscribe(response => {
        this._partner = response;
        this.getImagesForPartner(this._partner?.data.uuid || '');
      })
    });
  }

  private getImagesForPartner(partnerUUID: string) {
    this.imagesService.getImagesForProduct("ORGANISATION", partnerUUID, 'logo').subscribe(response => {
      this._partnerImages = response;
    });
  }


  get partnerImage() {
    return (this._partnerImages.data.length) ? this._partnerImages.data[0].original.url : '/assets/images/shared/default-user-icon.png';
  }

  get partner() {
    return this._partner;
  }

  get partnerLocation() {
    if (this._partner) {
      return this._partner?.data.contact.street_name + ', ' + this._partner?.data.contact.city + ', ' + this._partner?.data.contact.post_code;
    }
    return '';
  }

  get isDescExpandedAnimationString() {
    return (this.isDescrExpanded) ? 'in' : 'out';
  }

  get labels() {
    return Pages[this._language];
  }

  get workingTime() : WorkHours {
    return this._partner?.data.opening_hours || 
    {
      monday: [''],
      tuesday: [''],
      wednesday: [''],
      thursday: [''],
      friday: [''],
      saturday: [''],
      sunday: ['']
    };
  }

  openDocument(document: string) {
    window.open(this._assetsDocumentStringPath + document, '_blank')
  }

  get files() {
    return Documents;
  }

}
